import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerNavigationSidebarResourceBundleDe(i18next: i18n): void {
  i18next.addResourceBundle('de', 'record-it-components', {
    pageLayout: {
      NavigationSidebar: {
        logout: 'Logout',
        userProfile: 'Profil'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}